module.exports = __webpack_public_path__ + "img/natte-ingredienten.dd232970.jpg";